/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class NumberOfCopiesRule {
  /**
  * Whether the rule is enabled
  */
  'enabled': boolean;
  /**
  * The minimum number of copies
  */
  'minCopies': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "minCopies",
      "baseName": "minCopies",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NumberOfCopiesRule.attributeTypeMap;
  }

  public constructor() {
  }
}

